module.exports = __webpack_public_path__ + "img/02.8fad9973.png";